module.exports = __webpack_public_path__ + "img/outputdata-image5.718adce9.png";